import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Web/Mobile App Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <PageHeading
        title='Web/Mobile App Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'Web/Mobile App Development'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='Custom Web & Mobile Application Development'
          subtitle='End-to-End Software Solutions'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          At Dappster Studio, we specialize in creating high-performance, scalable, and user-friendly web and mobile applications. Whether you're a startup or an enterprise, our development services are designed to bring your ideas to life with modern technologies and industry best practices.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          Our team excels in delivering custom web development and mobile app solutions using cutting-edge frameworks like React, React Native, Next.js, and Flutter. We focus on responsive design, seamless UX/UI, and cross-platform compatibility to ensure your digital product succeeds across devices.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Services Section */}
      <Div className="container">
        <SectionHeading
          title='Our Web & App Development Services'
          subtitle='Delivering Scalable, Secure, and Engaging Applications'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='Custom Web Development'
              subtitle='Tailored websites and web apps with dynamic functionality and secure architecture.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Mobile App Development'
              subtitle='Native and cross-platform mobile apps built using React Native and Flutter.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='Progressive Web Apps (PWA)'
              subtitle='Blending the best of web and mobile with fast, installable, offline-capable experiences.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='Cross-Platform Development'
              subtitle='One codebase, multiple platforms—maximize reach and minimize cost.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='UI/UX Design Services'
              subtitle='Pixel-perfect design and seamless user journeys to enhance engagement and retention.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='App Maintenance & Support'
              subtitle='Continuous monitoring, performance optimization, and updates to keep your app thriving.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries We Serve'
          subtitle='Digital Solutions Tailored for Every Sector'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/cart-icon.svg'
              title='E-Commerce'
              subtitle='High-converting online stores with intuitive design and secure transactions.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/healthcare-icon.svg'
              title='Healthcare'
              subtitle='HIPAA-compliant apps for patient engagement, telehealth, and records management.'
            />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon='/images/icons/education-icon.svg'
              title='Education'
              subtitle='E-learning platforms with interactive content and remote classroom features.'
            />
          </Div>
        </Div>
        <Div className="row mt-lg-5" >
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/money-icon.svg'
              title='Finance & Banking'
              subtitle='Secure fintech solutions, payment gateways, and budgeting tools.'
            />
          </Div>
          <Div className="col-lg-6">
            <IconBox
              icon='/images/icons/truck-icon.svg'
              title='Logistics & Transportation'
              subtitle='Real-time tracking apps, route optimization, and fleet management systems.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
